import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=00042ea1&scoped=true&"
import script from "./Tag.vue?vue&type=script&lang=js&"
export * from "./Tag.vue?vue&type=script&lang=js&"
import style0 from "./Tag.vue?vue&type=style&index=0&id=00042ea1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00042ea1",
  null
  
)

export default component.exports